export default __webpack_public_path__ + "5db7a33a6ee1313cd6c1d4c5935977b0.svg";